import { ShieldOff } from 'lucide-react';

export function AuditorForbiddenPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-base px-4">
      <div className="w-full max-w-md text-center">
        <ShieldOff className="mx-auto mb-4 h-12 w-12 text-text-tertiary" />
        <h1 className="mb-2 text-2xl font-bold text-text-primary">Access Denied</h1>
        <p className="text-text-secondary">
          You do not have permission to access this resource.
          If you believe this is an error, contact the organisation that invited you.
        </p>
      </div>
    </div>
  );
}
